import { createContext, useContext, type ReactNode } from 'react';

import { useSubscribeWithStars } from './useSubscribeWithStars';

type SubscriptionPaymentContextValue = ReturnType<typeof useSubscribeWithStars>;

const SubscriptionPaymentContext = createContext<SubscriptionPaymentContextValue | undefined>(
  undefined
);

interface SubscriptionPaymentProviderProps {
  children: ReactNode;
}

export const SubscriptionPaymentProvider = ({ children }: SubscriptionPaymentProviderProps) => {
  const payment = useSubscribeWithStars();

  return (
    <SubscriptionPaymentContext.Provider value={payment}>
      {children}
    </SubscriptionPaymentContext.Provider>
  );
};

export const useSubscriptionPayment = (): SubscriptionPaymentContextValue => {
  const context = useContext(SubscriptionPaymentContext);

  if (!context) {
    throw new Error('useSubscriptionPayment must be used within a SubscriptionPaymentProvider');
  }

  return context;
};
